import { CountryCode } from '@agentnet/utils';
import { AddressFields } from 'ui-kit/form/interfaces/AddressModal';
import { Transferor } from '../../types';
import { AddressType, TransferorType } from '../constants';

export const getInitialTransferorData = (): Omit<Transferor, 'id'> => ({
  transferorType: TransferorType.Individual,
  address: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  } as AddressFields,
  addressType: AddressType.Foreign, // Default to "Principal Place of Business (U.S.)"
  foreignBusinessNoUSLocation: false,
  primaryUSAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  } as AddressFields,
  foreignBusinessAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  } as AddressFields,
  foreignPrincipalAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  } as AddressFields,
  identification: {
    type: '',
    number: '',
    jurisdiction: '',
  },
  status: 'incomplete',
});
